import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { InfoPage, PortalOneColumnLayout } from 'components/PortalStructure';
import { InfoPageHeaderSection, InfoPageHeaderTitle, InfoPageSection, InfoPageTitle1 } from 'components';
import { Helmet } from 'react-helmet';
const { asyncConnect } = require('redux-connect');
require('./style.css');

interface IProps {
	baseUrlClient?: string;
}

@asyncConnect([
	{
		promise: () => {
			return Promise.all([]);
		},
	},
])
@connect((state: IStore) => ({
	baseUrlClient: state.fetchDefault.baseUrlClient,
}))
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class PortalPrivacyPolicySL extends React.Component<IProps, any> {
	public render() {
		const siteTitle = 'Politika zasebnosti';
		const siteDescription = 'Politika zasebnosti description';
		const siteKeywords = 'Politika zasebnosti keywords';
		const siteImage = this.props.baseUrlClient + '/images/logo.png';
		const siteUrl = this.props.baseUrlClient + '/privacypolicy/sl';

		return (
			<PortalOneColumnLayout>
				<InfoPage>
					<InfoPageHeaderSection>
						<img src={require('../../../containers/Html/icons/symbol1.svg')} alt="glossiq icon" />
						<InfoPageHeaderTitle>Politika zasebnosti</InfoPageHeaderTitle>
					</InfoPageHeaderSection>
					<InfoPageHeaderSection>
						<p>
							Glossiq ("mi", "naš" ali "nas") se zavezuje k varovanju vaše zasebnosti. Ta politika zasebnosti
							pojasnjuje, kako se zbirajo, uporabljajo in razkrivajo vaši osebni podatki s strani Glossiq.
						</p>

						<p>
							Ta politika zasebnosti velja za našo spletno stran in pripadajoče poddomene (skupno imenovane "Naša
							storitev"), skupaj z našo aplikacijo, Glossiq. Z dostopom do naše storitve ali njeno uporabo potrjujete,
							da ste prebrali, razumeli in se strinjate z našim zbiranjem, shranjevanjem, uporabo in razkrivanjem vaših
							osebnih podatkov, kot je opisano v tej politiki zasebnosti in naših pogojih uporabe.
						</p>
					</InfoPageHeaderSection>
					<InfoPageSection>
						<InfoPageTitle1>Definicije in ključni izrazi</InfoPageTitle1>
						<p>
							Da bi stvari čim bolj jasno pojasnili v tej politiki zasebnosti, so vsakič, ko se sklicujemo na te izraze,
							strogo opredeljeni kot:
						</p>
						<ul>
							<li>
								Piškotek: majhna količina podatkov, ki jih ustvari spletna stran in jih shrani vaš spletni brskalnik.
								Uporablja se za identifikacijo vašega brskalnika, zagotavljanje analitike, zapomnitev informacij o vas,
								kot so vaša jezikovna nastavitev ali prijavni podatki.
							</li>

							<li>
								Podjetje: ko ta politika omenja "Podjetje," "mi," "nas" ali "naš," se nanaša na Glossiq d.o.o., (Velika
								pot 15, SI-5250 Solkan), ki je odgovorno za vaše podatke v skladu s to politiko zasebnosti.
							</li>

							<li>Država: kjer sta Glossiq ali lastnika/ustanovitelja Glossiq, v tem primeru Slovenija.</li>

							<li>
								Stranka: se nanaša na podjetje, organizacijo ali osebo, ki se prijavi za uporabo storitve Glossiq za
								upravljanje odnosov s potrošniki ali uporabniki storitev.
							</li>

							<li>
								Naprava: katera koli naprava, povezana z internetom, kot so telefon, tablica, računalnik ali katera koli
								druga naprava, ki se lahko uporablja za obisk Glossiq in uporabo storitev.
							</li>

							<li>
								IP naslov: Vsaki napravi, povezani z internetom, je dodeljena številka, imenovana naslov internetnega
								protokola (IP). Te številke se običajno dodeljujejo v geografskih blokih. IP naslov se pogosto uporablja
								za identifikacijo lokacije, s katere se naprava povezuje z internetom.
							</li>

							<li>
								Osebje: se nanaša na posameznike, ki so zaposleni pri Glossiq ali so z nami sklenili pogodbo za
								opravljanje storitev v imenu ene od strank.
							</li>

							<li>
								Osebni podatki: vsaka informacija, ki neposredno, posredno ali v povezavi z drugimi informacijami -
								vključno s številko osebnega identifikacijskega dokumenta - omogoča identifikacijo ali določitev naravne
								osebe.
							</li>

							<li>
								Storitev: se nanaša na storitev, ki jo zagotavlja Glossiq, kot je opisano v ustreznih pogojih (če so na
								voljo) in na tej platformi.
							</li>

							<li>
								Storitev tretje osebe: se nanaša na oglaševalce, sponzorje tekmovanj, promocijske in marketinške
								partnerje ter druge, ki zagotavljajo našo vsebino ali katerih izdelki ali storitve bi vas lahko
								zanimale.
							</li>

							<li>Spletna stran: Glossiq spletna stran, ki je dostopna prek te spletne povezave: www.glossiq.com </li>

							<li>Vi: oseba ali subjekt, ki se je registriral pri Glossiq za uporabo storitev.</li>
						</ul>

						<InfoPageTitle1>Katere informacije zbiramo?</InfoPageTitle1>

						<p>
							O vas zbiramo informacije, ko obiščete našo spletno stran, se registrirate na naši strani, oddate
							naročilo, se prijavite na naše novice, odgovorite na anketo ali izpolnite obrazec.
						</p>
						<ul>
							<li>Ime / Uporabniško ime </li>

							<li>Telefonske številke </li>

							<li>E-naslovi </li>

							<li>Naslovi za pošiljanje </li>

							<li>Naslovi za obračunavanje </li>

							<li>Številke debetnih/kreditnih kartic </li>

							<li>Starost </li>

							<li>Geslo </li>
						</ul>

						<p>
							Prav tako zbiramo informacije z mobilnih naprav za boljšo uporabniško izkušnjo, čeprav so te funkcije
							povsem izbirne:
						</p>

						<ul>
							<li>
								Lokacija (GPS): Lokacijski podatki pomagajo ustvariti natančno predstavitev vaših interesov, kar se
								lahko uporabi za bolj natančno in relevantno oglaševanje potencialnim strankam.
							</li>
							<li>
								Telefonski imenik (seznam stikov): Seznam stikov omogoča lažjo uporabo uporabniku, saj dostop do stikov
								iz aplikacije prihrani veliko časa.
							</li>
							<li>
								Kamera (slike): Dodeljevanje dovoljenja za kamero omogoča uporabniku, da slike prenese neposredno s
								kamere.
							</li>
							<li>
								Galerija fotografij (slike): Dodeljevanje dostopa do galerije slik omogoča uporabniku, da slike iz
								galerije naloži v aplikacijo.
							</li>
						</ul>

						<InfoPageTitle1>Kdaj Glossiq uporablja informacije končnih uporabnikov od tretjih oseb?</InfoPageTitle1>

						<p>
							Glossiq bo zbral podatke končnih uporabnikov, potrebne za zagotavljanje storitev Glossiq-a našim strankam.
							Zbiramo lahko javno dostopne informacije s spletnih mest družbenih medijev, ki ste jih navedli. Katere
							vaše informacije spletna mesta družbenih medijev objavijo kot javne, lahko nadzirate tako, da obiščete ta
							spletna mesta in spremenite svoje nastavitve zasebnosti.
						</p>

						<InfoPageTitle1>Kdaj Glossiq uporablja informacije končnih uporabnikov od tretjih oseb?</InfoPageTitle1>

						<p>
							Glossiq bo zbral podatke končnih uporabnikov, potrebne za zagotavljanje storitev Glossiq-a našim strankam.
							Zbiramo lahko javno dostopne informacije s spletnih mest družbenih medijev, ki ste jih navedli. Katere
							vaše informacije spletna mesta družbenih medijev objavijo kot javne, lahko nadzirate tako, da obiščete ta
							spletna mesta in spremenite svoje nastavitve zasebnosti.
						</p>

						<InfoPageTitle1>Kdaj Glossiq uporablja informacije strank od tretjih oseb?</InfoPageTitle1>

						<p>
							Nekatere informacije prejmemo od tretjih oseb, ko stopite v stik z nami. Na primer, ko nam posredujete
							svoj e-poštni naslov, da izkažete zanimanje za postati stranka našega portala, prejmemo informacije od
							tretje osebe, ki Glossiqu zagotavlja avtomatizirane storitve za odkrivanje goljufij. Prav tako občasno
							zbiramo informacije, ki so javno dostopne na spletnih mestih družbenih medijev. Katere vaše informacije
							spletna mesta družbenih medijev objavijo kot javne, lahko nadzirate tako, da obiščete ta spletna mesta in
							spremenite svoje nastavitve zasebnosti.
						</p>

						<InfoPageTitle1>Ali delimo informacije, ki jih zberemo, s tretjimi osebami?</InfoPageTitle1>

						<p>
							Informacije, ki jih zberemo, lahko delimo s tretjimi osebami, vključno s ponudniki oglaševanja, sponzorji
							nagrad, promocijskimi partnerji in trženjskimi partnerji ter drugimi, ki zagotavljajo našo vsebino ali
							katerih izdelki ali storitve menimo, da bi vas lahko zanimale. Prav tako jih lahko delimo s trenutnimi in
							bodočimi podružnicami ter poslovnimi partnerji ter če smo vključeni v združitev, prodajo sredstev ali
							drugo prestrukturiranje podjetja. Vaše osebne in neosebne informacije lahko delimo ali prenesemo tudi na
							naše naslednike.
						</p>

						<InfoPageTitle1>Kako uporabljamo zbrane informacije?</InfoPageTitle1>
						<p>Katero koli informacijo, ki jo od vas zberemo, lahko uporabimo na enega od naslednjih načinov: </p>
						<ul>
							<li>
								Za prilagajanje vaše izkušnje (vaše informacije nam pomagajo bolje odgovoriti na vaše individualne
								potrebe)
							</li>
							<li>
								Za izboljšanje naše spletne strani (neprestano si prizadevamo izboljšati ponudbo naše spletne strani na
								podlagi informacij in povratnih informacij, ki jih prejmemo od vas)
							</li>
							<li>
								Za izboljšanje storitev za stranke (vaše informacije nam pomagajo učinkoviteje odgovarjati na vaše
								zahteve za storitve za stranke in podporo)
							</li>
							<li>Za obdelavo transakcij</li>
							<li>Za izvajanje natečajev, promocij, anket ali drugih funkcij spletnega mesta </li>
							<li>Za pošiljanje občasnih elektronskih sporočil</li>
						</ul>

						<InfoPageTitle1>Kako uporabljamo vaš e-poštni naslov?</InfoPageTitle1>

						<p>
							Z vnosom svojega e-poštnega naslova na tej spletni strani se strinjate, da boste od nas prejemali e-pošto.
							Sodelovanje na katerem koli od teh seznamov za pošiljanje e-pošte lahko kadar koli prekličete, tako da
							kliknete povezavo za odjavo ali drugo možnost za odjavo, ki je vključena v ustrezno e-pošto. E-pošto
							pošiljamo samo osebam, ki so nam dovolile, da jih kontaktiramo, bodisi neposredno bodisi prek tretje
							osebe. Ne pošiljamo nezaželene komercialne e-pošte, saj sovražimo neželeno pošto enako kot vi. Z vnosom
							svojega e-poštnega naslova se prav tako strinjate, da nam dovolite uporabo vašega e-poštnega naslova za
							ciljanje na občinstvo strank na spletnih mestih, kot je Facebook, kjer prikazujemo prilagojeno oglaševanje
							specifičnim osebam, ki so se prijavile za prejemanje komunikacije od nas. E-poštne naslove, ki so
							posredovani samo prek strani za obdelavo naročil, bomo uporabljali izključno za namen pošiljanja
							informacij in posodobitev v zvezi z vašim naročilom. Če pa ste isti e-poštni naslov posredovali prek druge
							metode, ga lahko uporabimo za kateri koli od namenov, navedenih v tej politiki. Opomba: Če se kadarkoli
							želite odjaviti od prejemanja prihodnjih e-poštnih sporočil, vključujemo podrobna navodila za odjavo na
							dnu vsakega e-poštnega sporočila.
						</p>

						<InfoPageTitle1>Kako dolgo hranimo vaše informacije?</InfoPageTitle1>

						<p>
							Vaše informacije hranimo le tako dolgo, kot jih potrebujemo, da vam zagotovimo storitve Glossiq in
							izpolnimo namene, opisane v tej politiki. To velja tudi za vse, s katerimi delimo vaše informacije in ki
							opravljajo storitve v našem imenu. Ko ne več uporabljamo vaših informacij in ni potrebe, da jih hranimo,
							da bi izpolnili naše pravne ali regulatorne obveznosti, jih bomo bodisi odstranili iz naših sistemov ali
							depersonalizirali, da vas ne bomo mogli identificirati.
						</p>

						<InfoPageTitle1>Kako varujemo vaše informacije?</InfoPageTitle1>

						<p>
							Uvedli smo različne varnostne ukrepe, da bi ohranili varnost vaših osebnih informacij, ko oddate naročilo
							ali vnesete, predložite ali dostopate do svojih osebnih informacij. Ponujamo uporabo varnega strežnika.
							Vse občutljive/informacije o kreditnih karticah se prenašajo prek tehnologije Secure Socket Layer (SSL) in
							nato šifrirajo v bazo podatkov ponudnika plačilnih prehodov, do katere imajo dostop samo pooblaščene osebe
							s posebnimi dostopnimi pravicami do takih sistemov, in so dolžne ohranjati informacije zaupne. Po
							transakciji vaše zasebne informacije (številke kreditnih kartic, socialne varnosti, finančne informacije
							itd.) niso več shranjene. Vendar ne moremo zagotoviti ali jamčiti za absolutno varnost informacij, ki jih
							prenašate na Glossiq, ali zagotoviti, da vaših informacij na storitvi ne bi bilo mogoče dostopati,
							razkriti, spreminjati ali uničiti zaradi kršitve katerega koli od naših fizičnih, tehničnih ali
							upravljavskih varoval.
						</p>

						<InfoPageTitle1>Ali se lahko moje informacije prenesejo v druge države?</InfoPageTitle1>

						<p>
							Glossiq je registriran v Sloveniji. Informacije, zbrane prek naše spletne strani, neposrednih interakcij z
							vami ali uporabe naših pomožnih storitev, se lahko občasno prenesejo v naše pisarne, do osebja ali tretje
							oseb, ki se nahajajo po vsem svetu, in jih je mogoče pregledovati in gostiti kjerkoli na svetu, vključno s
							državami, ki morda nimajo zakonov splošne uporabe, ki urejajo uporabo in prenos takih podatkov. V največji
							možni meri, ki jo dovoljuje veljavno pravo, s tem, ko uporabljate katero od zgoraj navedenega,
							prostovoljno soglašate s prenosom prek meja in gostovanjem takih informacij.
						</p>

						<InfoPageTitle1>Je informacija, zbrana prek storitve Glossiq, varna?</InfoPageTitle1>

						<p>
							Sprejemamo previdnostne ukrepe za zaščito varnosti vaših informacij. Imamo fizične, elektronske in upravne
							postopke, ki pomagajo varovati varnost vaših informacij, preprečujejo nepooblaščen dostop, vzdržujejo
							varnost podatkov in pravilno uporabljajo vaše informacije. Vendar pa ljudje in varnostni sistemi niso
							nezmotljivi, vključno s šifrirnimi sistemi. Poleg tega lahko ljudje storijo namerna kazniva dejanja,
							naredijo napake ali ne upoštevajo pravil. Zato čeprav si z razumnimi prizadevanji prizadevamo za zaščito
							vaših osebnih informacij, njene absolutne varnosti ne moremo zagotoviti. Če veljavno pravo nalaga kakršno
							koli nedoločljivo dolžnost za zaščito vaših osebnih informacij, se strinjate, da bo za merjenje naše
							skladnosti s to dolžnostjo uporabljeno namerno nevestno ravnanje.
						</p>

						<InfoPageTitle1>Osebje </InfoPageTitle1>

						<p>
							Če ste zaposleni ali prosilec za delo pri Glossiq, zbiramo informacije, ki jih prostovoljno posredujete
							nam. Zbrane informacije uporabljamo za namene kadrovskega upravljanja, da bi zagotovili ugodnosti
							zaposlenim in preverjali prijavljene prosilce.
						</p>

						<p>
							Na nas se lahko obrnete, da (1) posodobite ali popravite svoje informacije, (2) spremenite svoje želje v
							zvezi z komunikacijo in drugimi informacijami, ki jih prejemate od nas, ali (3) prejmete zapis informacij,
							ki se nanašajo na vas. Takšne posodobitve, popravki, spremembe in brisanja ne bodo vplivali na druge
							informacije, ki jih vzdržujemo, ali informacije, ki smo jih posredovali tretjim osebam v skladu s to
							politiko zasebnosti pred takšno posodobitvijo, popravkom, spremembo ali izbrisom.
						</p>

						<InfoPageTitle1>Prodaja poslovanja </InfoPageTitle1>

						<p>
							Pridržujemo si pravico, da v primeru prodaje, združitve ali drugega prenosa vseh ali bistvenega dela
							sredstev Glossiq ali katerega koli njegovih korporacijskih podružnic (kot je določeno tukaj), ali tistega
							dela Glossiq ali katerega koli njegovih korporacijskih podružnic, ki se nanaša na Storitev, ali v primeru,
							da prekinemo svoje poslovanje ali vložimo ali proti nam vložimo prošnjo za stečaj, reorganizacijo ali
							podoben postopek, prenesemo informacije tretji osebi, pod pogojem, da se tretja oseba strinja z
							upoštevanjem pogojev te politike zasebnosti.
						</p>

						<InfoPageTitle1>Podružnice </InfoPageTitle1>

						<p>
							Našim korporacijskim podružnicam lahko razkrijemo vaše informacije (vključno z osebnimi informacijami). Za
							namene te politike zasebnosti "korporacijska podružnica" pomeni vsako osebo ali entiteto, ki neposredno
							ali posredno nadzira, nadzoruje ali je pod skupnim nadzorom z Glossiq, bodisi prek lastništva ali kako
							drugače. Vse informacije o vas, ki jih posredujemo našim korporacijskim podružnicam, bodo te korporacijske
							podružnice obravnavale v skladu s pogoji te politike zasebnosti.
						</p>

						<InfoPageTitle1>Veljavno pravo </InfoPageTitle1>

						<p>
							Ta politika zasebnosti se ureja z zakoni Slovenije, ne glede na določbo o izbiri zakona. Strinjate se z
							izključno pristojnostjo sodišč v povezavi z vsako tožbo ali sporom, ki se pojavi med strankami v okviru
							ali v zvezi s to politiko zasebnosti, razen za tiste posameznike, ki imajo pravico do vložitve zahtevkov v
							skladu z Zavetjem zasebnosti ali švicarsko-ameriškim okvirom.
						</p>

						<p>
							Zakoni Slovenije, izvzeti iz njegovih pravil o konfliktu zakonov, bodo urejali to pogodbo in vašo uporabo
							spletne strani. Vaša uporaba spletne strani je lahko podvržena tudi drugim lokalnim, državnim, nacionalnim
							ali mednarodnim zakonom.
						</p>

						<p>
							Z uporabo storitve Glossiq ali neposrednim stikom z nami izražate svoje sprejemanje te politike
							zasebnosti. Če se s to politiko zasebnosti ne strinjate, se ne bi smeli vključevati v našo spletno stran
							ali uporabljati naših storitev. Nadaljnja uporaba spletne strani, neposredno sodelovanje z nami ali
							spremljanje objave sprememb te politike zasebnosti, ki ne vplivajo pomembno na uporabo ali razkritje vaših
							osebnih informacij, pomeni, da sprejemate te spremembe.
						</p>

						<InfoPageTitle1>Ali lahko posodobim ali popravim svoje informacije? </InfoPageTitle1>

						<p>
							Pravice, ki jih imate, da zahtevate posodobitve ali popravke informacij, ki jih Glossiq zbira, so odvisne
							od vašega odnosa z Glossiq-om. Osebje lahko posodobi ali popravi svoje informacije v skladu z našimi
							internimi politikami podjetja glede zaposlovanja.
						</p>
						<p>
							Stranke imajo pravico zahtevati omejitev določenih uporab in razkritij osebno prepoznavnih informacij, kot
							sledi. Obrnete se lahko na nas, da (1) posodobite ali popravite svoje osebno prepoznavne informacije, (2)
							spremenite svoje preference glede komunikacije in drugih informacij, ki jih prejemate od nas, ali (3)
							izbrišete osebno prepoznavne informacije o vas, ki so shranjene v naših sistemih (v skladu s spodnjim
							odstavkom), tako da prekličete svoj račun. Takšne posodobitve, popravki, spremembe in brisanja ne bodo
							vplivali na druge informacije, ki jih vzdržujemo, ali informacije, ki smo jih posredovali tretjim osebam v
							skladu s to politiko zasebnosti pred takšno posodobitvijo, popravkom, spremembo ali izbrisom. Da bi
							zaščitili vašo zasebnost in varnost, lahko sprejmemo razumne ukrepe (na primer zahtevamo edinstveno
							geslo), da preverimo vašo identiteto, preden vam omogočimo dostop do profila ali naredimo popravke.
							Odgovorni ste za ohranjanje tajnosti vašega edinstvenega gesla in informacij o računu ves čas.
						</p>
						<p>
							Zavedati se morate, da ni tehnološko mogoče odstraniti iz našega sistema vsakega posameznega zapisa
							informacij, ki ste nam jih posredovali. Potreba po ustvarjanju varnostnih kopij naših sistemov za zaščito
							informacij pred nenamernimi izgubami pomeni, da lahko obstaja kopija vaših informacij v obliki, ki je ni
							mogoče izbrisati, kar bo za nas težko ali nemogoče najti. Takoj po prejemu vaše zahteve bodo vse osebne
							informacije, shranjene v aktivno uporabljenih bazah podatkov, posodobljene, popravljene, spremenjene ali
							izbrisane, kot je primerno, takoj in v obsegu, ki je razumno in tehnično izvedljiv.
						</p>
						<p>
							Če ste končni uporabnik in želite posodobiti, izbrisati ali prejeti kakršne koli informacije, ki jih imamo
							o vas, to lahko storite tako, da stopite v stik z organizacijo, v kateri ste stranka.
						</p>

						<InfoPageTitle1>Vaše soglasje </InfoPageTitle1>

						<p>
							Posodobili smo našo politiko zasebnosti, da vam zagotovimo popolno preglednost nad tem, kaj se nastavi, ko
							obiščete našo spletno stran, in kako se uporablja. Z uporabo naše storitve Glossiq, registracijo računa
							ali nakupom soglašate s politiko zasebnosti in se strinjate z njenimi pogoji.
						</p>

						<InfoPageTitle1>Povezave do drugih spletnih strani </InfoPageTitle1>

						<p>
							Ta politika zasebnosti velja le za Storitve. Storitve lahko vsebujejo povezave do drugih spletnih strani,
							ki jih ne upravlja ali nadzira Glossiq. Nismo odgovorni za vsebino, natančnost ali mnenja izražena na teh
							spletnih straneh, in takšne spletne strani niso preverjene, spremljane ali preverjane glede natančnosti
							ali celovitosti s strani nas. Pomnite, da ko uporabite povezavo za prehod iz Storitev na drugo spletno
							stran, naša politika zasebnosti več ni veljavna. Vaše brskanje in interakcija na katerikoli drugi spletni
							strani, vključno s tistimi, ki imajo povezavo na naši platformi, je podvržena pravilom in politikam te
							spletne strani. Takšni tretji ponudniki lahko uporabljajo svoje piškotke ali druge metode za zbiranje
							informacij o vas.
						</p>

						<InfoPageTitle1>Oglaševanje </InfoPageTitle1>

						<p>
							Ta spletna stran lahko vsebuje oglase tretjih oseb in povezave do spletnih strani tretjih oseb. Glossiq ne
							daje nobenih izjav o natančnosti ali primernosti informacij, ki so vključene v teh oglasih ali na teh
							spletnih straneh, in ne sprejema nobene odgovornosti ali odgovornosti za ravnanje ali vsebino teh oglasov
							in spletnih strani ter ponudbe tretjih oseb.
						</p>

						<p>
							Oglaševanje omogoča, da je Glossiq in mnoge druge spletne strani ter storitve, ki jih uporabljate,
							brezplačne. Trdo delamo, da so oglasi varni, nevsiljivi in čim bolj relevantni.
						</p>

						<p>
							Oglasi tretjih oseb in povezave do drugih spletnih strani, kjer so prikazane blago ali storitve, niso
							odobritve ali priporočila s strani Glossiq teh spletnih strani, blaga ali storitev. Glossiq ne prevzema
							nobene odgovornosti za vsebino oglasov, obljube, ki so dane, ali kakovost/zanesljivost izdelkov ali
							storitev, ki so ponujeni v vseh oglasih.
						</p>

						<InfoPageTitle1>Piškotki za oglaševanje</InfoPageTitle1>

						<p>
							Ti piškotki sčasoma zbirajo informacije o vaši dejavnosti na spletu na tej spletni strani in drugih
							spletnih storitvah, da bi naredili spletno oglaševanje bolj relevantno in učinkovito za vas. To je znano
							kot oglaševanje na osnovi interesov. Prav tako izvajajo funkcije, kot je preprečevanje neprekinjenega
							ponavljanja istega oglasa in zagotavljanje pravilnega prikaza oglasov za oglaševalce. Brez piškotkov je
							zelo težko, da oglaševalec doseže svoje občinstvo ali ve, koliko oglasov je bilo prikazanih in koliko
							klikov so prejeli.
						</p>

						<InfoPageTitle1>Podatki o plačilih </InfoPageTitle1>

						<p>
							Kar zadeva vaše podatke o kreditni kartici ali drugih podatkih za obdelavo plačil, ki ste nam jih
							posredovali, se zavezujemo, da bodo ti zaupni podatki shranjeni na najvarnejši možni način.
						</p>

						<InfoPageTitle1>Zasebnost otrok</InfoPageTitle1>

						<p>
							Ne obravnavamo oseb, mlajših od 13 let. Zavestno ne zbiramo osebnih prepoznavnih informacij od oseb,
							mlajših od 13 let. Če ste starš ali skrbnik in veste, da je vaš otrok posredoval osebne podatke, nas
							prosim kontaktirajte. Če ugotovimo, da smo zbrali osebne podatke od oseb, mlajših od 13 let, brez
							preverjanja starševskega soglasja, bomo nemudoma sprejeli ukrepe, da te informacije odstranimo iz svojih
							strežnikov.
						</p>

						<InfoPageTitle1>Spremembe v naši politiki zasebnosti </InfoPageTitle1>

						<p>
							Lahko se spremenimo našo storitev in pravilnike, in morda bomo morali spremeniti tudi to politiko
							zasebnosti, da bi točno odražali našo storitev in pravilnike. Razen če zakon ne zahteva drugače, vas bomo
							obvestili (na primer preko naše storitve), preden bomo spremenili to politiko zasebnosti in vam dali
							možnost, da jih pregledate, preden stopijo v veljavo. Nato, če še naprej uporabljate storitev, boste
							zavezani posodobljeni politiki zasebnosti. Če se ne strinjate s to ali katero koli posodobljeno politiko
							zasebnosti, lahko izbrišete svoj račun.
						</p>

						<InfoPageTitle1>Storitve tretjih oseb </InfoPageTitle1>

						<p>
							Lahko prikažemo, vključimo ali omogočimo vsebine tretjih oseb (vključno s podatki, informacijami,
							aplikacijami in drugimi izdelki storitvami) ali zagotovimo povezave do spletnih strani ali storitev
							tretjih oseb ("Storitve tretjih oseb").
						</p>
						<p>
							Priznavate in se strinjate, da Glossiq ne bo odgovoren za nobene storitve tretjih oseb, vključno z njihovo
							natančnostjo, popolnostjo, pravočasnostjo, veljavnostjo, skladnostjo z avtorskimi pravicami, zakonitostjo,
							primernostjo, kakovostjo ali katerim koli drugim vidikom. Glossiq ne prevzema in ne bo imel nobene
							odgovornosti ali odgovornosti do vas ali katerih koli drugih oseb ali subjektov za storitve tretjih oseb.
						</p>
						<p>
							Storitve tretjih oseb in povezave do njih se zagotavljajo izključno kot priročnost za vas, in do njih
							dostopate in jih uporabljate povsem na lastno odgovornost ter podvrženo pogojem in določilom tretjih oseb.
						</p>

						<InfoPageTitle1>Piškotki </InfoPageTitle1>

						<p>
							Glossiq uporablja "piškotke" za prepoznavanje delov naše spletne strani, ki ste jih obiskali. Piškotek je
							majhen kos podatkov, shranjen na vašem računalniku ali mobilni napravi s strani vašega spletnega
							brskalnika. Uporabljamo piškotke, da izboljšamo delovanje in funkcionalnost naše spletne strani, vendar
							niso bistveni za njeno uporabo. Brez piškotkov določene funkcionalnosti, kot so videoposnetki, morda ne
							bodo na voljo, ali pa boste morali vsakič, ko obiščete spletno stran, vnesti svoje prijavne podatke, saj
							se ne bi mogli spomniti, da ste se prej prijavili. Večina spletnih brskalnikov omogoča onemogočanje
							uporabe piškotkov. Če piškotke onemogočite, morda ne boste mogli pravilno ali sploh dostopati do
							funkcionalnosti naše spletne strani. Nikoli ne shranjujemo osebnih prepoznavnih informacij v piškotke.
						</p>

						<InfoPageTitle1>Blokiranje in onemogočanje piškotkov ter podobnih tehnologij</InfoPageTitle1>

						<p>
							Kjer koli se nahajate, lahko tudi nastavite brskalnik, da blokira piškotke in podobne tehnologije, vendar
							lahko ta ukrep blokira naše bistvene piškotke in prepreči pravilno delovanje naše spletne strani, in morda
							ne boste mogli v celoti izkoristiti vseh njenih funkcij in storitev. Prav tako se zavedajte, da boste
							morda izgubili nekatere shranjene informacije (npr. shranjeni prijavni podatki, nastavitve strani), če
							blokirate piškotke v svojem brskalniku. Različni brskalniki vam ponujajo različne kontrole. Onemogočanje
							piškotka ali kategorije piškotkov ne izbriše piškotka iz vašega brskalnika, to morate storiti sami znotraj
							svojega brskalnika, za več informacij obiščite meni za pomoč v svojem brskalniku.
						</p>

						<InfoPageTitle1>Storitve za ponovno trženje </InfoPageTitle1>

						<p>
							Uporabljamo storitve za ponovno trženje. Kaj je ponovno trženje? V digitalnem marketingu je ponovno
							trženje (ali retargeting) praksa prikazovanja oglasov po internetu ljudem, ki so že obiskali vašo spletno
							stran. Omogoča vašemu podjetju, da se zdi, kot da "sledi" ljudem po internetu, tako da prikazuje oglase na
							spletnih straneh in platformah, ki jih najpogosteje uporabljajo.
						</p>

						<InfoPageTitle1>Facebook Pixel </InfoPageTitle1>

						<p>
							Facebook Pixel je analitično orodje, ki vam omogoča merjenje učinkovitosti vašega oglaševanja z
							razumevanjem dejanj, ki jih ljudje izvajajo na vaši spletni strani. Pixel lahko uporabite za: Zagotovitev,
							da se vaši oglasi prikazujejo pravim ljudem. Facebook Pixel lahko zbira informacije s vaše naprave, ko
							uporabljate storitev. Facebook Pixel zbira informacije, ki se hranijo v skladu z njegovo politiko
							zasebnosti.
						</p>

						<InfoPageTitle1>Tehnologije sledenja </InfoPageTitle1>

						<ul>
							<li>
								<p>Google Maps API</p>
								<p>
									Google Maps API je robustno orodje, ki se lahko uporablja za ustvarjanje prilagojenih zemljevidov,
									iskalnih zemljevidov, funkcij prijave, prikaza sinhroniziranih živih podatkov s lokacijo, načrtovanja
									poti ali ustvarjanja mashupov, da naštejemo le nekaj možnosti.
								</p>
								<p>Google Maps API lahko zbira informacije od vas in vaše naprave zaradi varnostnih namenov.</p>
								<p>Google Maps API zbira informacije, ki se hranijo v skladu z njegovo politiko zasebnosti.</p>
							</li>
							<li>
								<p>Piškotki</p>
								<p>
									Uporabljamo piškotke za izboljšanje učinkovitosti in funkcionalnosti naše spletne strani, vendar niso
									nujni za njihovo uporabo. Vendar brez teh piškotkov določena funkcionalnost, kot so videoposnetki,
									morda ne bo na voljo ali pa boste morali vsakič, ko obiščete spletno stran, vnesti svoje podatke za
									prijavo, saj se ne bi mogli spomniti, da ste se prej prijavili.
								</p>
							</li>
							<li>
								<p>Lokalno shranjevanje</p>
								<p>
									Lokalno shranjevanje, včasih znano kot DOM shranjevanje, spletnim aplikacijam zagotavlja metode in
									protokole za shranjevanje podatkov na strani odjemalca. Spletno shranjevanje omogoča trajno
									shranjevanje podatkov, podobno kot piškotki, vendar z bistveno večjo kapaciteto in brez informacij,
									shranjenih v glavi HTTP zahtevka.
								</p>
							</li>
							<li>
								<p>Seje</p>
								<p>
									Seja je majhen podatkovni kos, shranjen na vašem računalniku ali mobilni napravi prek spletnega
									brskalnika.
								</p>
							</li>
						</ul>

						<InfoPageTitle1>Informacije o Splošni uredbi o varstvu podatkov (GDPR)</InfoPageTitle1>

						<p>
							Morda zbiramo in uporabljamo vaše informacije, če ste iz Evropskega gospodarskega prostora (EGP), in v tem
							delu naše politike zasebnosti vam bomo natančno pojasnili, kako in zakaj se te podatki zbirajo ter kako
							vzdržujemo te podatke pod zaščito pred ponovnim kopiranjem ali napačno uporabo.
						</p>

						<InfoPageTitle1>Kaj je GDPR? </InfoPageTitle1>

						<p>
							GDPR je zakon o zasebnosti in varstvu podatkov, ki ureja zaščito podatkov rezidentov EU s strani podjetij
							ter povečuje nadzor, ki ga imajo rezidenti EU nad svojimi osebnimi podatki.
						</p>

						<p>
							GDPR je pomemben za vsako globalno delujoče podjetje, ne samo za podjetja v EU in za prebivalce EU.
							Podatki naših strank so pomembni ne glede na to, kje so locirani, zato smo kot osnovni standard za vse
							naše operacije po vsem svetu uvedli kontrole GDPR.
						</p>

						<InfoPageTitle1>Kaj so osebni podatki? </InfoPageTitle1>

						<p>
							Vsak podatek, ki se nanaša na prepoznavno ali prepoznano posamezno osebo. GDPR pokriva širok spekter
							informacij, ki bi se lahko uporabile same ali v kombinaciji z drugimi informacijami, za identifikacijo
							osebe. Osebni podatki segajo prek imena ali e-poštnega naslova osebe. Nekateri primeri vključujejo
							finančne informacije, politična mnenja, genetske podatke, biometrične podatke, IP naslove, fizični naslov,
							spolno usmerjenost in etnično pripadnost.
						</p>

						<p>Načela varstva podatkov vključujejo zahteve, kot so:</p>

						<ul>
							<li>
								Zbrane osebne podatke je treba obdelati na pošten, zakonit in pregleden način ter jih uporabljati le na
								način, ki bi ga oseba upravičeno pričakovala.
							</li>
							<li>
								Osebni podatki naj se zbirajo le za izpolnitev določenega namena in naj se uporabljajo samo za ta namen.
								Organizacije morajo navesti, zakaj potrebujejo osebne podatke, ko jih zbirajo.
							</li>
							<li>Osebni podatki naj se hranijo le toliko časa, kolikor je potrebno za izpolnitev namena.</li>
							<li>
								Osebe, ki jih pokriva GDPR, imajo pravico dostopa do svojih osebnih podatkov. Prav tako lahko zahtevajo
								kopijo svojih podatkov ter zahtevajo posodobitev, izbris, omejitev ali prenos svojih podatkov drugi
								organizaciji.
							</li>
						</ul>

						<InfoPageTitle1>Zakaj je GDPR pomemben? </InfoPageTitle1>

						<p>
							GDPR uvaja nekatere nove zahteve glede tega, kako bi morale družbe varovati osebne podatke posameznikov,
							ki jih zbirajo in obdelujejo. Prav tako povečuje pomen skladnosti z večjimi kaznimi za kršitve. Poleg teh
							dejstev je preprosto pravilno. Pri Glossiq močno verjamemo, da je zasebnost vaših podatkov zelo pomembna,
							in že imamo vzpostavljene trdne prakse zasebnosti in varnostne prakse, ki presegajo zahteve te uredbe.
						</p>

						<InfoPageTitle1>Pravice posameznikov - dostop, prenosljivost in izbris podatkov</InfoPageTitle1>

						<p>
							Zavezani smo, da našim strankam pomagamo izpolniti zahteve glede pravic posameznikov v zvezi z GDPR.
							Glossiq obdeluje ali shranjuje vse osebne podatke v popolnoma preglednih ponudnikih, skladnih z DPA. Vse
							pogovore in osebne podatke hranimo do 6 let, razen če je vaš račun izbrisan. V tem primeru vse podatke
							odstranimo v skladu z našimi Pogoji uporabe in Pravilnikom o zasebnosti, vendar jih ne bomo hranili dlje
							kot 60 dni.
						</p>

						<p>
							Zavedamo se, da morate, če sodelujete z EU strankami, zagotoviti možnost dostopa, posodobitve, pridobitve
							in odstranitve osebnih podatkov. Že od začetka smo omogočili pomoč in vedno vam dajemo dostop do vaših
							podatkov in podatkov vaših strank. Naša ekipa za podporo strankam je tu, da odgovori na vsa vprašanja, ki
							jih imate glede dela z API.
						</p>

						<InfoPageTitle1>Prebivalci Kalifornije </InfoPageTitle1>

						<p>
							Zakon o zasebnosti potrošnikov v Kaliforniji (CCPA) zahteva, da razkrijemo kategorije osebnih podatkov, ki
							jih zbiramo, ter kako jih uporabljamo, kategorije virov, od katerih zbiramo osebne podatke, in tretje
							strani, s katerimi jih delimo, kar smo že razložili zgoraj.
						</p>

						<p>
							Prav tako smo dolžni posredovati informacije o pravicah, ki jih imajo prebivalci Kalifornije po
							kalifornijskem zakonu. Lahko uveljavljate naslednje pravice:
						</p>

						<ul>
							<li>
								Pravica do vednosti in dostopa. Lahko vložite preverjeno zahtevo za informacije glede: (1) kategorij
								osebnih podatkov, ki jih zbiramo, uporabljamo ali delimo; (2) namenov, za katere zbiramo ali uporabljamo
								kategorije osebnih podatkov; (3) virov, iz katerih zbiramo osebne podatke; in (4) specifičnih delov
								osebnih podatkov, ki smo jih zbrali o vas.
							</li>
							<li>
								Pravica do enakega obravnavanja. Ne bomo diskriminirali, če uveljavljate svoje pravice zasebnosti.
							</li>
							<li>
								Pravica do izbrisa. Lahko vložite preverjeno zahtevo za zaprtje svojega računa in izbris osebnih
								podatkov o vas, ki smo jih zbrali.
							</li>
							<li>
								Zahteva, da podjetje, ki prodaja osebne podatke potrošnika, ne prodaja osebnih podatkov potrošnika.
							</li>
						</ul>

						<p>
							Če vložite zahtevo, imamo en mesec časa, da vam odgovorimo. Če želite uveljavljati katere koli od teh
							pravic, nas kontaktirajte.
						</p>

						<p>Osebnih podatkov naših uporabnikov ne prodajamo.</p>

						<p>Za več informacij o teh pravicah, nas kontaktirajte.</p>

						<InfoPageTitle1>Zakon o zasebnosti na spletu v Kaliforniji (CalOPPA)</InfoPageTitle1>

						<p>
							CalOPPA zahteva, da razkrijemo kategorije osebnih podatkov, ki jih zbiramo, ter kako jih uporabljamo,
							kategorije virov, od katerih zbiramo osebne podatke, in tretje strani, s katerimi jih delimo, kar smo že
							razložili zgoraj.
						</p>

						<p>Uporabniki CalOPPA imajo naslednje pravice: </p>

						<ul>
							<li>
								Pravica do vednosti in dostopa. Lahko vložite preverjeno zahtevo za informacije glede: (1) kategorij
								osebnih podatkov, ki jih zbiramo, uporabljamo ali delimo; (2) namenov, za katere zbiramo ali uporabljamo
								kategorije osebnih podatkov; (3) virov, iz katerih zbiramo osebne podatke; in (4) specifičnih delov
								osebnih podatkov, ki smo jih zbrali o vas.
							</li>
							<li>
								Pravica do enakega obravnavanja. Ne bomo diskriminirali, če uveljavljate svoje pravice zasebnosti.
							</li>
							<li>
								Pravica do izbrisa. Lahko vložite preverjeno zahtevo za zaprtje svojega računa in izbris osebnih
								podatkov o vas, ki smo jih zbrali.
							</li>
							<li>
								Zahteva, da podjetje, ki prodaja osebne podatke potrošnika, ne prodaja osebnih podatkov potrošnika.
							</li>
						</ul>

						<p>Osebnih podatkov naših uporabnikov ne prodajamo.</p>

						<p>Za več informacij o teh pravicah, nas kontaktirajte.</p>

						<InfoPageTitle1>Kontaktirajte nas </InfoPageTitle1>

						<p>Če imate vprašanja, nas lahko kontaktirate preko e-pošte:</p>

						<p>
							<a href="mailto:support@glossiq.com">support@glossiq.com</a>
						</p>
					</InfoPageSection>
				</InfoPage>
				<Helmet
					title={siteTitle}
					link={[{ rel: 'canonical', href: siteUrl }]}
					meta={[
						{ property: 'og:title', content: siteTitle },
						{ property: 'og:image', content: siteImage },
						{ property: 'og:description', content: siteDescription },
						{ property: 'og:url', content: siteUrl },
						{ name: 'title', content: siteTitle },
						{ name: 'description', content: siteDescription },
						{ name: 'keywords', content: siteKeywords },
					]}
				/>
			</PortalOneColumnLayout>
		);
	}
}

export { PortalPrivacyPolicySL };
